const setAccessToken = (accessToken: string) => {
  localStorage.setItem('a_t', accessToken);
}

const getAccessToken = () => {
  return localStorage.getItem('a_t');
}

const clearAccessToken = () => {
  localStorage.removeItem('a_t');
}

export default {
  setAccessToken,
  getAccessToken,
  clearAccessToken
}